import React from 'react';
import { ClientErrorBoundary } from '../ClientErrorBoundary';
import { getIssues } from './getIssues';
import { getNodes, getAreAllTargetsEmpty } from './nodesHelper';
import { renderIssueTitle, renderIssuesContent } from './issuesRenderers';
import { getErrorMessage } from './getErrorMessage';
import { isNonProduction, isAvailabilityUndefined, isAvailabilityPublic } from './globalHelpers';

export const ReplaceWithIssues = ({ children, parent, elementName, targetNodes,  targetPaths, hideChildrenWithIssues }) => {

  const nodes = getNodes(targetNodes, parent, targetPaths);
  const areAllTargetsEmpty = getAreAllTargetsEmpty(nodes, parent, targetPaths, targetNodes)
  const issues = getIssues(nodes);

  const canReplaceChidrenToShow = !!issues.length || areAllTargetsEmpty
  
  let childrenToShow = children || <></>

  if (isNonProduction()) {
    const errorMessage = getErrorMessage({nodes, elementName, hideChildrenWithIssues, children});

    if (canReplaceChidrenToShow) {
      return getIssueBlock(errorMessage, issues, nodes, elementName)           
    }

    const fallback = <h4 className={'decoratorErrorBoundaryFallback'}>{errorMessage}</h4>
    return wrapWithErrorBoundary(childrenToShow, fallback) 
  }

  if (hideChildrenWithIssues && canReplaceChidrenToShow) {
    childrenToShow = <></>    
  }

  if (!isAvailabilityUndefined() && !isAvailabilityPublic()) {
    return wrapWithErrorBoundary(childrenToShow)
  }  

  return <>{childrenToShow}</>;
};


function getIssueBlock(errorMessage, issues, nodes, elementName) {
  return <div className="issuesWrapper">
    <div className="issues">
      {renderIssueTitle(errorMessage, issues)}
      {renderIssuesContent(nodes, issues, elementName)}
    </div>
  </div>;
}

function wrapWithErrorBoundary(childrenToShow, fallback = <></>) {
  return <ClientErrorBoundary fallBack={fallback}>
    {childrenToShow}
  </ClientErrorBoundary>;
}

